import React, { forwardRef } from 'react'

import Box, { type BoxProps } from '../box'
import { BoxLink, type BoxLinkProps } from '../link'

const sizes = {
  small: { px: '12', py: '12', borderRadius: 'medium' },
  medium: { px: '16', py: '16', borderRadius: 'medium' },
  large: { px: '24', py: '24', borderRadius: 'medium' },
  xlarge: { px: '32', py: '32', borderRadius: 'medium' }
} as const

export type CardProps = (BoxProps | BoxLinkProps) & {
  size?: keyof typeof sizes
}

const sharedProps = {
  bg: 'white',
  boxShadow: 'medium',
  overflowX: 'hidden',
  overflowY: 'hidden'
} as const

// a white, softly shadowed Box; with `path` it is a link
const Card = forwardRef<HTMLElement, CardProps>(
  ({ size = 'medium', ...props }, ref) => {
    const sizeProps = sizes[size]
    return 'path' in props && props.path ? (
      <BoxLink
        ref={ref}
        {...sharedProps}
        {...sizeProps}
        {...(props as BoxLinkProps)}
      />
    ) : (
      <Box ref={ref} {...sharedProps} {...sizeProps} {...props} />
    )
  }
)
Card.displayName = 'Card'

export default Card
